import React, { useCallback, useContext, useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import {
  AiFillFolder,
  AiFillWindows,
  AiOutlineClose,
  AiOutlineDownload,
} from "react-icons/ai";
import { setReminder } from "../../features/UserActions";
import { WsContext } from "../../App";
import { CmdMessage } from "../../core/CmdMessage";
import { useDispatch } from "react-redux";
import { BiUpload } from "react-icons/bi";
import { FileUploadStatus } from "../../core/Helper";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

export default function PopupOpenRemoteFile(props) {
  // called from "RadioResult.js"
  const [winState, setWinState, dataX] = props.winState;
  const { userDetail } = props;
  const [msg, setMsg] = useState(null);

  const [ws, setWs] = useContext(WsContext);
  const [wsOK, setWsOK] = useState(false);

  const handleClose = (value) => {
    let result = { comfirmType: value, resultType: value };
    winState.action(result);
    setWinState({ show: false });
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (winState?.show === true) {
      //console.log("Popup-Open-Remote-File-Said");
      //console.log(dataX);
      //console.log(userDetail);
      //console.log(ws);
      // let k = new CmdMessage();
      // k.StudyID = -1;
      // k.SrcStaff = userDetail.staffid;
      // k.DestStaff = userDetail.staffid;
      // k.ReqCommand = "32000";
      // k.SrcSessionType = 3;
      // k.DestSessionType = 2;
      // k.TargetSessionType = 3;
      // k.StudyInstanceUid = dataX?.studyInfo.study_instance_uid;
      // k.StudyID = dataX?.studyInfo?.pacs_study_id;
      // ws?.sendMessage(JSON.stringify(k));
      // document.addEventListener("wscalling", getWsMsg);
    }
    return () => {
      //setWsOK(false);
      //document.removeEventListener("wscalling", getWsMsg);
    };
  }, [winState.show]);

  //** When received message from socket-server  */
  //** Can be checked detail at WebSocketUser.js(/page/login/webSocketUser.js) */
  const getWsMsg = (e) => {
    let comeCMD = new CmdMessage();
    comeCMD = e.detail;

    if (comeCMD?.ReqCommand === "32000OK") {
      setWsOK(true);
    } else if (comeCMD?.ReqCommand === "32000XX") {
      setWsOK(false);
    } else if (comeCMD?.ReqCommand === "32000ND") {
      setWsOK(false);
      requestDownload();
    }
  };

  const requestDownload = () => {
    console.log("start");
    let k = new CmdMessage();
    k.SrcStaff = userDetail.staffid;
    k.DestStaff = userDetail.staffid;
    k.ReqCommand = "32201";
    k.SrcSessionType = 3;
    k.DestSessionType = 2;
    k.TargetSessionType = 2;
    k.StudyInstanceUid = dataX?.studyInfo?.study_instance_uid;
    k.StudyID = dataX?.studyInfo?.pacs_study_id;
    // console.log(JSON.stringify(k));
    ws?.sendMessage(JSON.stringify(k));

    dispatch(
      setReminder({
        show: true,
        message: (
          <div style={{ marginTop: "10px" }}>
            <div style={{ color: "white" }}>{"ตรวจไม่พบข้อมูลภาพบน PC"}</div>
            <div>{"ระบบกำลังดำเนินการเพือรับภาพ จากต้นทาง"}</div>
          </div>
        ),
        type: "success",
      })
    );
  };

  return (
    <MyModal show={winState && winState.show} size="lg" centered>
      <ModalHeaderBlack>
        <div
          style={{
            color: "white",
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Open with
        </div>
      </ModalHeaderBlack>
      <ModalBodyBlack>
        <div
          style={{
            flex: "1",
            display: "flex",
            marginLeft: "auto",
            marginRight: "auto",
            background: "none",
            borderRadius: "5px",
            justifyContent: "center",
            flexDirection: "row",
            paddingBlock: "20px",
            paddingInline: "20px",
          }}
        >
          {/* <Button
            style={buttonStyle}
            hidden={!(winState.serviceEnabled && wsOK)}
            onClick={() => handleClose(1)}
          >
            <AiFillFolder style={buttonIconStyle} />
            Folder
          </Button>
          <Button
            style={buttonStyle}
            hidden={!(winState.serviceEnabled && wsOK)}
            //hidden={!wsOK}
            onClick={() => handleClose(2)}
          >
            <AiFillWindows style={buttonIconStyle} />
            Viewer
          </Button> */}
          {/* DOWNLOAD NORMALLY */}
          {winState.imageOnServerStatus == FileUploadStatus.Deleted ? (
            <Button
              variant="warning"
              style={{
                ...(dataX?.studyInfo?.uploaded === "y"
                  ? buttonStyle
                  : buttonDisable),
              }}
              disabled={dataX?.studyInfo?.uploaded == "y" ? false : true}
              onClick={() => handleClose(3)}
            >
              <BiUpload style={{ ...buttonIconStyle, color: "#0000ff" }} />
              แจ้ง Upload ภาพเก่า
            </Button>
          ) : (
            <></>
          )}

          {winState?.imageOnServerStatus == FileUploadStatus.Uploaded ? (
            <Button
              style={{
                ...(dataX?.studyInfo?.uploaded === "y"
                  ? buttonStyle
                  : buttonDisable),
              }}
              disabled={dataX?.studyInfo?.uploaded == "y" ? false : true}
              onClick={() => handleClose(3)}
            >
              <AiOutlineDownload style={buttonIconStyle} />
              Download
            </Button>
          ) : (
            <></>
          )}
          {/*  */}
          <Button
            variant="danger"
            style={buttonStyle}
            onClick={() => setWinState({ show: false })}
          >
            <AiOutlineClose style={buttonIconStyle} />
            ปิด
          </Button>
        </div>
      </ModalBodyBlack>
    </MyModal>
  );
}

const buttonStyle = {
  margin: "2px",
  display: "flex",
  // flex: "1",
  // flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
  // maxWidth: "140px",
};
const buttonDisable = {
  margin: "5px",
  flex: "1",
  flexDirection: "column",
  justifyContent: "center",
  alignItem: "center",
  backgroundColor: "grey",
  border: "none",
};

const buttonIconStyle = {
  color: "yellow",
  flex: "1",
  margin: "5px 5px 0 0px",
};
